import Menu from '@components/v2/ui/Menu/Menu';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import { Box } from '@mui/material';
import { X } from 'lucide-react';
import FilterChip from '../../../../components/FilterV3/components/FilterChip/FilterChip';
import { useMenu } from '../../../../hooks/useMenu';
import LangEnum from '../../../../lang/LangEnum';
import { OrderProductsTestIds } from '../../../../utils/testIds/OrderProducts.testIds';
import { useTranslation } from '../../../translation/TranslationContext';

const LABEL_MAX_WIDTH = 200;

export interface OrderProductsConditionOption {
  id: string;
  label: string;
}

export interface OrderProductsConditionSelection {
  options: OrderProductsConditionOption[];
  selectedId?: string;
  onSelect: (conditionId: string) => void;
  onClear: () => void;
}

interface OrderProductsConditionChipProps {
  label: string;
  selection: OrderProductsConditionSelection;
}

const OrderProductsConditionChip = ({ label, selection }: OrderProductsConditionChipProps) => {
  const { translate } = useTranslation();
  const { anchorEl, isOpen, open, close, runAction } = useMenu();
  const { options, selectedId, onSelect, onClear } = selection;

  return (
    <>
      <FilterChip
        primaryLabel={translate(LangEnum.GLOBAL_DIVISION)}
        title={label}
        isActive={isOpen}
        testId={OrderProductsTestIds.CONDITION_CHIP}
        onLabelClick={open}
        secondaryLabel={
          <Box
            component="span"
            sx={{
              display: 'block',
              maxWidth: LABEL_MAX_WIDTH,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </Box>
        }
        secondAction={{
          icon: X,
          ariaLabel: translate(LangEnum.GLOBAL_CLEAR),
          onClick: onClear,
        }}
      />

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        testId={OrderProductsTestIds.CONDITION_CHIP_MENU}
        onClose={close}
      >
        <MenuItem onClick={(event) => runAction(event, onClear)}>
          {translate(LangEnum.GLOBAL_FEMALE_ALL)}
        </MenuItem>

        {options.map((option) => (
          <MenuItem
            key={option.id}
            selected={option.id === selectedId}
            onClick={(event) => runAction(event, () => onSelect(option.id))}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default OrderProductsConditionChip;
